module.exports = __webpack_public_path__ + "img/world.80255c6c.png";